/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

// MUI
import { Grid } from '@material-ui/core';

// Helpers
import { occasionsMapping } from '../Common/Helpers/Helpers';
import { RecipientBookContext } from '../Common/Context/RecipientBookContext';

// Components
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import RecipientBookBrandColorIcons from '../Common/Helpers/RecipientBookBrandColorIcons';
import { getSSRDeviceType } from '../../../../../../../state/ducks/App/App-Selectors';
import { CommonStyles, commonUseStyles } from '../../../../style/commonStyles';

const OccasionsList = (props) => {
    // THIS FILE IS BEING USED BY BOTH DESKTOP AND MOBILE FILES!!!!
    const { setSelectedOccasionToEdit, setIsOccasionsEditing } = useContext(RecipientBookContext);
    const isMobile = useSelector(getSSRDeviceType) === 'mobile';
    const dispatch = useDispatch();
    const history = useHistory();
    const customClasses = commonUseStyles();
    const useCommonStyles = CommonStyles();

    /* lines 124-126 is temporary logic per business requirement to only show birthday occasion on the recipient list */
    /* later on, likely need refactoring to support more complex logic to show a single occasion more modularly, like VDAY for romantic recips */
    const birthdayOccasionIndex = props.occasions.findIndex(({ occasion }) => occasion === '2');
    const birthdayObject = birthdayOccasionIndex > -1 ? props.occasions[birthdayOccasionIndex] : {};
    const { occasion, dateDD, dateMM } = birthdayObject;
    return (
        /* logic for mapping the occasions icon to the occasions here */
        <>
            {
                birthdayOccasionIndex > -1 && dateDD !== '' && dateMM !== '' ? (
                    <Grid container item xs={12}>
                        <Grid container item xs={6} spacing={1} className={useCommonStyles.occassionGrid}>
                            <Grid item>
                                <RecipientBookBrandColorIcons className={props.globalClasses.iconStyle} icon='Birthday' />
                            </Grid>
                            <Grid item className={`occasionName ${isMobile ? customClasses.smallFont : customClasses.mediumFont}`}
>
                                {occasionsMapping[occasion].name} - {`${dateMM}/${dateDD}`}
                            </Grid>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container alignContent='center' alignItems='center' spacing={1}>
                        <Grid item>
                            <RecipientBookBrandColorIcons className={props.globalClasses.iconStyle} icon='Birthday' />
                        </Grid>
                        <Grid item>
                            <button
                                type="button"
                                className={props.globalClasses.commonBtn}
                                onClick={() => {
                                    dispatch(trackEvent({
                                        eventName: "address_book_interaction",
                                        interaction_type: "add_birthday_start",
                                        eventCategory: "Address Book",
                                        eventAction: "Interaction",
                                        eventLabel: "Add Birthday Start"
                                    }))
                                    props.setCurrentRecipient && props.setCurrentRecipient(props.recipient);
                                    props.setIsEditingRecipient(true)
                                    setSelectedOccasionToEdit('2')
                                    setIsOccasionsEditing(true);
                                    history.push(`/account/address-book/${props.recipient.rcpId}`);
                                }}>
                                Add Birthday
                            </button>
                        </Grid>
                    </Grid>
                )
            }
        </>
    );
};

export default OccasionsList;
